import { render, staticRenderFns } from "./EstimatePage.vue?vue&type=template&id=536bbcd2&scoped=true&"
import script from "./EstimatePage.vue?vue&type=script&lang=js&"
export * from "./EstimatePage.vue?vue&type=script&lang=js&"
import style0 from "./EstimatePage.vue?vue&type=style&index=0&id=536bbcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bbcd2",
  null
  
)

export default component.exports